export default __webpack_public_path__ + "static/media/ic_vn_flag.fa794809.svg";